import React from "react";
import DateRangeField from "components/InputField/DateRangeField";

const labels = {
  date_from: "Starts from",
  date_to: "To",
};

const ToolsAddWebinars = ({
  onAddCheckedWebinarsClick,
  count,
  onChangeQuery,
  onDateRangeChange,
  query,
}) => {
  return (
    <div>
      <div className="container_admin_user">
        <DateRangeField
          onChange={onDateRangeChange}
          fromValue={query.date_from}
          toValue={query.date_to}
          fieldName={"date"}
          className="calendar_picker"
          labels={labels}
        />
        <div className="col s4 search_admin">
          <input id="search" type="submit" className="validate" />
          <label htmlFor="search">
            <i className="material-icons icon_search">search</i>
          </label>
          <input
            type="search"
            placeholder="Search"
            value={query.title}
            onChange={(e) => onChangeQuery("title", e.target.value)}
          />
          <i
            onClick={(e) => onChangeQuery("title", "")}
            className="material-icons icon_close"
          >
            close
          </i>
        </div>
      </div>
      <div className="admin_list">
        <h5>
          Webinars (<span>{count}</span>)
        </h5>
        <a className="button_classic" onClick={onAddCheckedWebinarsClick}>
          Add Webinars
        </a>
      </div>
    </div>
  );
};

export default ToolsAddWebinars;



// WEBPACK FOOTER //
// ./src/components/Admin/ClientUrls/AddWebinars/Toolbar.jsx